import { Button, Icon } from '@atom/mui';
import { AddIcon, PlaylistAddCheckIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';

import classes from './tasks.module.css';

type TasksEmptyStateProps = {
  requireTaskType: boolean;
  onChooseTemplate: () => void;
  onAddBlank: () => void;
};

const styles = {
  chooseTemplateButton: {
    width: '13.5rem',
    textTransform: 'none',
  },
  withoutTemplateButton: {
    width: '13.5rem',
    textTransform: 'none',
    color: colors.neutral.dim,
    borderColor: colors.neutral.silver,
  },
};

const TasksEmptyState = ({
  requireTaskType,
  onChooseTemplate,
  onAddBlank,
}: TasksEmptyStateProps) => {
  return (
    <div className={classes.tasksEmpty}>
      <Icon
        icon={PlaylistAddCheckIcon}
        color={colors.neutral.silver}
        size="xxl"
      />
      <div className={classes.tasksEmptyTitle}>No Task Created</div>
      <div className={classes.tasksEmptyBody}>
        Tasks help plan your work activities. You can create and rename tasks
        now, and edit full details after work is created.
      </div>
      <Button
        variant="contained"
        color="primary"
        onClick={onChooseTemplate}
        startIcon={
          <Icon icon={PlaylistAddCheckIcon} color={colors.neutral.white} />
        }
        sx={styles.chooseTemplateButton}
        data-cy="createWorkModalEmptyChooseTemplate"
      >
        Choose from Templates
      </Button>
      {!requireTaskType && (
        <Button
          variant="outlined"
          onClick={onAddBlank}
          startIcon={<Icon icon={AddIcon} color={colors.neutral.dim} />}
          sx={styles.withoutTemplateButton}
          data-cy="createWorkModalEmptyWithoutTemplate"
        >
          Without a Template
        </Button>
      )}
    </div>
  );
};

export default TasksEmptyState;
